import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type LayoutTypes = 'pending' | 'main-layout' | 'recruit-layout' | 'ekyc' | 'error';

interface LayoutState {
  layoutType: LayoutTypes;
  videoUrl?: string;
}

const initialState: LayoutState = {
  layoutType: 'pending',
};

export const layoutSlice = createSlice({
  name: 'layoutReducer',
  initialState,
  reducers: {
    toggleLayout($state, action: PayloadAction<LayoutTypes>) {
      $state.layoutType = action.payload;
    },
    setVideoUrl($state, action: PayloadAction<string>) {
      $state.videoUrl = action.payload;
    },
  },
});

export const {
  toggleLayout,
} = layoutSlice.actions;

export default layoutSlice.reducer;
